/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as yup from "yup";
import { Role } from "~/generated/graphql";

export const ApiKeySchema = yup.object().shape({
  description: yup.string().required(),
  role: yup.string().required(),
  applications: yup.array().default([]),
});

export type UpdateApiKeyInput = {
  id: string;
  input: {
    description: string | undefined;
    role: Role;
    applications: string[];
  };
};
